import React from 'react'

const Address = ({ height, width }) => {
  return (
    <div>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        viewBox="0 0 12.241 15.453"
      >
        <g data-name="location-pin-svgrepo-com (2)">
          <path
            data-name="Path 932"
            d="M10.621 17.453c2.81-2.891 5.621-5.479 5.621-8.672A5.7 5.7 0 0 0 10.621 3 5.7 5.7 0 0 0 5 8.781c0 3.193 2.81 5.781 5.621 8.672z"
            style={{
              fill: 'none',
              stroke: '#b1b1b1',
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
            }}
            transform="translate(-4.5 -2.5)"
          />
          <path
            data-name="Path 933"
            d="M11.409 11.818A2.409 2.409 0 1 0 9 9.409a2.409 2.409 0 0 0 2.409 2.409z"
            transform="translate(-5.288 -3.288)"
            style={{
              fill: 'none',
              stroke: '#b1b1b1',
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
            }}
          />
        </g>
      </svg>
    </div>
  )
}

export default Address
